// extracted by mini-css-extract-plugin
export default {"container":"vBpOu","back-office":"_3pP1t","backOffice":"_3pP1t","success":"_3NR4b","error":"_3-15B","info":"_2Wnb3","center":"_27KXd","static":"_1LrWD","close":"_1zfJz"};